// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1-907","noInteraction":"EventWrapper_noInteraction__1bQ7f","pointerPassthrough":"EventWrapper_pointerPassthrough__3b8W2"};